// @flow
 import type {Action} from '../../../state/types'

export type OnClickPlacePayload = {
  place: ServiceProvider,
}

const id = 'map/ON_CLICK_PLACE'

export const onClickPlace = (place: ServiceProvider): Action<OnClickPlacePayload> => ({
  type: id,
  payload: {
    place,
  }
})

onClickPlace.id = id
